import React from "react";
import { Button, Card, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

type Props = {
  message?: string;
  btnTitle?: string;
  goBackURL?: string | undefined;
};

const PageNotFound: React.FC<Props> = (props: Props) => {
  const navigate = useNavigate();

  const { message = "Page Not Found", btnTitle = "Go to Home", goBackURL = "/" } = props;

  return (
    <Container className="w-1170">
      <div className="text-center my-5">
        <Card className="nothing-available-card">
          <Card.Body>
            <Card.Title>
              <h1 className="text-center mb-3">404</h1>
              <h2>{message}</h2>
            </Card.Title>
            <p>
              Sorry but the page you are looking for does not exist.
              <br />
              It may be removed, renamed or is temporarily unavailable.
            </p>
            {btnTitle ? (
              <Button
                variant="secondary"
                className="btn-w-200"
                onClick={() => navigate(goBackURL, { replace: true })}
              >
                {btnTitle}
              </Button>
            ) : null}
          </Card.Body>
        </Card>
      </div>
    </Container>
  );
};

export default PageNotFound;
